// src/pages/Home.jsx
import { Box } from "@mui/material";
import HomeAbout from "../components/HomeAbout";
import Experience from "../components/Experience";
import Academics from "../components/Academics";
import Projects from "../components/Projects";
import Skills from "../components/Skills";
import Contact from "../components/Contact";
import Courses from "../components/Courses";
import ExtraCurricular from "../components/ExtraCurricular";
import { useEffect } from "react";

const Home = () => {
  useEffect(() => {
    const sectionId = sessionStorage.getItem("scrollTarget");
    if (sectionId) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      sessionStorage.removeItem("scrollTarget");
    }
  }, []);

  return (
    <Box>
      <HomeAbout />
      <Box id="experience">
        <Experience />
      </Box>
      <Box id="skills">
        <Skills />
      </Box>
      <Box id="projects">
        <Projects />
      </Box>

      <Box id="academics">
        <Academics />
      </Box>

      {/* If you ever want a nav item for this, use href="#courses" */}
      <Box id="courses">
        <Courses />
      </Box>

      <Box id="extracurricular">
        <ExtraCurricular />
      </Box>

      <Box id="contact">
        <Contact />
      </Box>
    </Box>
  );
};

export default Home;
